import { useState, useEffect } from 'react';
import { fetchContent, fetchPoliticas } from '../../services/parameter.service';

const useContentPoliticas = () => {
  const [contentPoliticas, setContentPoliticas] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const getContentPoliticas = async () => {
    setIsLoading(true);

    try {
      // const responseContent = await fetchContent('quienes somos');
      const responseContent = await fetchPoliticas();
      setContentPoliticas(responseContent.data.list);

      setIsLoading(false);
    } catch (error) {
      console.error(' ERROR EN useContentPoliticas --> ', error);
    }
  };

  useEffect(() => {
    getContentPoliticas();
  }, []);

  return {
    contentPoliticas,
  };
};

export default useContentPoliticas;
